import {Reducer} from "redux";
import {PledgerAction} from "@pledger/frontend-commons";

import {CreateSouscriptionActions} from "../CreateSouscriptionActions";
import {CurrentModuleId} from "../CurrentModuleId";
import {souscriptionCGPWServiceActions} from "../../../services/ws/SouscriptionCGP/souscriptionCGPWServiceActions";

const simulationURL = (state = '', action : PledgerAction) => {
    switch (action.type) {
        case CreateSouscriptionActions.SELECT_MODULE_TO_DISPLAY_ACTION.type:
            return action.payload.moduleId!==CurrentModuleId.CGP_TUNNEL ? '' : state;

        case souscriptionCGPWServiceActions.CREATE_SOUSCRIPTION_CGP_SIMULATION_SUCCEEDED_ACTION.type:
            return action.payload.data.simulationURL;
        default:
            return state;
    }
};


export interface SouscriptionCGPTunnelState {
    simulationURL : string;
 };

export const souscriptionCGPTunnelReducers : Reducer = (state={}, action)=> {
    return {
        simulationURL: simulationURL(state.simulationURL, action),
     }
}
